import React, { FC } from 'react';
import { Avatar } from '../../../../avatar/components/avatar';
import coin from '../../../../../assets/images/coin.png';
import PopoverPlayerAdditionalInfo from '../../../../playerAdditionalInfo/popoverPlayerAdditionalInfo/popoverPlayerAdditionalInfo';
import { IPlayer } from '@base/features/player/model/interfaces';

type PropsType = {
  player: IPlayer;
};

export const TablePlayerCard: FC<PropsType> = ({ player }: PropsType) => {
  return (
    <PopoverPlayerAdditionalInfo player={player} placement="right" key={player.pid}>
      <div
        className="table-list-player table-list-player--pointer table-list__content-playing-item"
        key={player.name}
      >
        <div className="table-list__content-playing-item table-list__avatar">
          <div className="table__avatar">
            <Avatar classes="" player={player} />
          </div>
        </div>
        <div className="table-list__nickname table-list__content-playing-item">
          <div>{player.name}</div>
          <div>
            {player.isTicketPlayer() ? (
              <img className="messages__author-ticket" src={coin} alt="ticket" />
            ) : null}
          </div>
        </div>
        <div className="table-list__rating table-list__content-playing-item">{player.rating}</div>
      </div>
    </PopoverPlayerAdditionalInfo>
  );
};
